export const CancelationPolicy = [
    {
        topic: ` Humbee shall not be responsible for any delivery of the order products and all delivery shall be effected directly by the Supplier.`,
        point: ``,
    },
    {
        topic: ` In case Supplier is not in position to fulfil the delivery, Supplier may at its discretion cancel the order and such cancellation shall be notified to Buyer by notification email or message to Buyer or any other mean.`,
        point: ``,
    },
    {
        topic: ` In case Buyer wishes to cancel the order, then no refund shall be processed, and credit note shall be issued by the Supplier or Humbee to Buyer. Buyer shall have to utilise the said credit note in three months from date of issue.`,
        point: ``,
    },
    {
        topic: `This Policy shall be deemed to part of the terms of use and all clauses of such policy shall be deemed to incorporated by reference.`,
        point: ``,
    },
]